<ng-container [formGroup]="formGroup" *ngIf="validators.length > 0">
  <legend>{{ 'Value Validators' | translate  | locale }}</legend>
  <nz-row [nzGutter]="16">
    <ng-container *ngFor="let control of validatorsFormArray.controls">
      <ng-container [formGroup]="control | AsFormGroup">
        <nz-col nzSm="24" nzMd="12">
          <nz-form-item style="width: 100%">
            <nz-row style="width: 100%">
              <nz-form-label nz-col nzSpan="5">{{
                control.value | ValidatorName : validators
              }}</nz-form-label>
              <nz-form-control nz-col nzSpan="17">
                <app-product-field
                  [controlName]="'ValidatorContent'"
                  [enableCreateOption]="false"
                  [formGroup]="control | AsFormGroup"
                  [field]="control.value | ValidatorToField : validators"
                >
                </app-product-field>
              </nz-form-control>
            </nz-row>
          </nz-form-item>
        </nz-col>
      </ng-container>
    </ng-container>
  </nz-row>
</ng-container>
